

import { useState } from 'react';

import gsap from "gsap";
import { useGSAP } from "@gsap/react";



import { HashLink as Link } from 'react-router-hash-link/dist/react-router-hash-link.cjs.production';
import xmenu from '../Asset/xmark-solid.svg'



function Navbar() {
const [togle, settogle] = useState(false)

useGSAP(() => {

  
  gsap.from(" #bood", {y: 20,delay:0.5 ,duration:1.5  ,opacity:0 ,repeat: -1 ,repeatDelay: 6
  });
  gsap.from(" #conta", {y: 20,delay:1 ,duration:1.5,  opacity:0 ,repeat: -1 ,repeatDelay: 6} );
  gsap.from(" #project", {y: 20,delay:1.5 ,duration:1.5, opacity:0 ,repeat: -1 ,repeatDelay: 6 } );
 
  gsap.from(" #Education", {y: 20,delay:2 ,duration:1.5 ,opacity:0,repeat: -1 ,repeatDelay: 6} );
  gsap.from(" #skill", {y: 20,delay:2.5 ,duration:1.5 ,opacity:0 ,repeat: -1 ,repeatDelay: 6} );
  gsap.fromTo("#logo", { x: 100, opacity: 0 ,scale:2 ,rotate:100 ,zoom:2}, { x: 0, opacity: 1, duration: 1, scale:1, ease: "ease.out", delay: 1.5,rotate:360 ,repeatDelay: 4 ,zoom:1  });
  gsap.fromTo("#mobileMenu", { x: 100, opacity: 0 ,scale:2 ,rotate:100 ,zoom:2}, { x: 0, opacity: 1, duration: 1, scale:1, ease: "ease.in", delay: 4,rotate:360 ,repeat: 2,repeatDelay: 8 ,zoom:1  });



})

const toglehanler = () =>{
  settogle(!togle)
  
 
}
const XmarkHandler = () =>{
  settogle(togle)
  if(togle===true){
    settogle(false)
  }

  
  
}

  
  return (
 <>
    <div className="fixed top-0 z-50 w-full h-16 items-center justify-center   drop-shadow " id='containe   ' >
  <div className="mx-auto flex max-w-7xl items-center  justify-between px-4 py-2 sm:px-6 lg:px-8  "   >
    <div className="inline-flex items-center space-x-2 ">
      
    <Link   to="#Landing" className='fixed left-0 top-0 w-10    h-10  rounded-full text-2xl  p-4 font-Pacifico text-fuchsia-500' id='logo'> Arbaz</Link>
    </div>
    {togle===false?(<>
    <div className="hidden  mt-2 justify-center items-l justify-items-center grow  md: lg:flex ml-8 tracking-wide font-serif"  >
            <ul className="ml-12 inline-flex justify-end w-full space-x-8">
              <li className='hover:underline ' id='bood'>
                <Link smooth
                  to="#Landing"
                  className="text-xl font-bold text-blue-500 hover:underline  font-serif focus-within:text-3xl hover:text-red-500 "
             
                >
                  Home
                </Link>
              </li>
             
              <li className='hover:underline ' id='conta'> 
                <Link
                smooth
                  to="#contact"
                  className="text-xl font-bold font-serif  text-blue-500  hover:text-red-500"
                >
                  Contact
                </Link>
              </li>
              <li className='hover:underline' id='project'>
                <Link
                smooth
                  to="#projects"
                  className="text-xl font-bold text-blue-500  font-serif hover:text-red-500"
                >
                  Projects
                </Link>
              </li>
              <li className='hover:underline' id='Education'>
                <Link
                smooth
                  to="#EducationHash"
                  className="text-xl font-bold font-serif text-blue-500  hover:text-red-500"
                >
                  Education
                </Link>
              </li>
             
              < li className='hover:underline' id='skill'>
                <Link
                smooth
                  to="#skills"
                  className="text-xl font-bold font-serif  text-blue-500  hover:text-red-500"
                >
                 Skills
                </Link>
              </li>
            </ul>
          </div></>):

          //mobile view 
          (<div className='flex md:flex items-center flex-col    h-screen w-screen backdrop:drop-shadow-md bg-black/75 '  > 

          
          <ul className="flex flex-col items-center w-full  mt-16  h-full m-4   " id='mobileMenu' >
               <li className='  w-2/3 text-center border-4   hover:border-green-300 rounded-xl align-middle  bg-black   shadow-blue-500/50 shadow-xl  h-10  ' id='mobileHome'>
                <Link
                smooth
                  to="#Landing"
                  className="text-sm font-semibold text-indigo-200 font-sans hover:text-red-500 "
                  onClick={XmarkHandler}
                >
                  Home
                </Link>
              </li>
      
              <li className=' w-2/3 text-center border-4   hover:border-green-300 rounded-xl align-middle  bg-black   shadow-blue-500/50 shadow-xl h-10'>
                <Link
                smooth
                to="#contact"
                  className="text-sm font-semibold text-indigo-200 hover:text-red-500"
                  onClick={XmarkHandler}
                >
                  Contact
                </Link>
              </li>
              <li className=' w-2/3 text-center border-4   hover:border-green-300 rounded-xl align-middle  bg-black   shadow-blue-500/50 shadow-xl h-10'>
                <Link
                smooth
             
                to="#projects"
                  className="text-sm font-semibold text-indigo-200 hover:text-red-500"
                  onClick={XmarkHandler}
                >
                  Projects
                </Link>
              </li>
              <li className=' w-2/3 text-center border-4   hover:border-green-300 rounded-xl align-middle  bg-black   shadow-blue-500/50 shadow-xl h-10'>
                <Link
                smooth
                  to="#Education"
                  className="text-sm font-semibold text-indigo-200 hover:text-red-500"
                  onClick={XmarkHandler}
                >
                  Education
                </Link>
              </li>
           
              < li className=' w-2/3 text-center border-4   hover:border-green-300 rounded-xl align-middle  bg-black   shadow-blue-500/50 shadow-xl h-10' >
                <Link
                smooth
                  to="#skills"
                  className="text-sm font-semibold text-indigo-200 hover:text-red-500"
                  onClick={XmarkHandler}
                >
                  Skills
                </Link>
              </li>
            </ul>
            </div>)}
   { !togle?(<div className="lg:hidden hover:underline fixed top-0 right-0 hover:cursor-pointer mr-4  " onClick={toglehanler}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
   
        viewBox="0 0 24 24"
        fill="red"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        className="h-8 w-8 cursor-pointer text-gray-950 "
      >
        <line x1="4" y1="12" x2="20" y2="12"></line>
        <line x1="4" y1="6" x2="20" y2="6"></line>
        <line x1="4" y1="18" x2="20" y2="18"></line>
      </svg>
    </div>):
    (<div className='lg:hidden hover:cursor-pointer  fixed top-0 align-middle right-0 flex justify-center items-center w-full'  onClick={XmarkHandler}> 
      <img src={xmenu} alt="menu" width={30} />
    </div>)}
  </div>
</div>

    </>


     

  );
}

export default Navbar;